import { isActiveMember, type TeamMemberRow } from "@/lib/team/types";
import { getDisplayEmail } from "@/lib/utils/display-email";

const normalize = (value: string) => value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export function filterMembers(
  members: TeamMemberRow[],
  f: { query: string; jobTitle: string; status: "active" | "inactive" | "all" },
  today = new Date().toISOString().slice(0, 10),
): TeamMemberRow[] {
  const q = normalize(f.query.trim());
  const qDigits = f.query.replace(/\D/g, "");
  return members.filter((member) => {
    if (f.jobTitle && member.job_title !== f.jobTitle) return false;
    const active = isActiveMember(member, today);
    if (f.status === "active" && !active) return false;
    if (f.status === "inactive" && active) return false;
    if (!q) return true;
    const text = normalize(`${member.full_name} ${getDisplayEmail(member.email) ?? ""}`);
    return text.includes(q) || (qDigits.length >= 3 && (member.cpf ?? "").includes(qDigits));
  });
}

export function jobTitleOptions(members: TeamMemberRow[]): string[] {
  return [...new Set(members.map((m) => m.job_title).filter((v): v is string => !!v))].sort((a, b) => a.localeCompare(b, "pt-BR"));
}
